import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CollapsibleImportSummary } from '../../../components/CollapsibleSummary';
import { IImportQuestionRejection, ImportQuestionRejectionReason } from '../projects.model';

interface IProps {
  isLastSummaryItem?: boolean;
  isPanelOpen: boolean;
  handlePanelToggle: () => void;
  rejectedQuestions: IImportQuestionRejection[];
  importedQuestionsCount: number;
  skippedQuestionsCount: number;
}

export function mapQuestionRejectionReason(reason: ImportQuestionRejectionReason): TranslationKey {
  switch (reason) {
    case ImportQuestionRejectionReason.DUPLICATED_TEXT:
      return 'duplicated_text';
    case ImportQuestionRejectionReason.EMPTY_SCOPE_LIST:
      return 'empty_scope_list';
    case ImportQuestionRejectionReason.INVALID_ANSWER_TYPE:
      return 'invalid_answer_type';
    case ImportQuestionRejectionReason.INVALID_SCOPE:
      return 'invalid_scope';
    default:
      return 'unknown';
  }
}

export const ImportQuestionsSummary = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const getRejectionReasons = (): string[] => {
    return props.rejectedQuestions.map((x) => {
      return `${x.text} - ${t(mapQuestionRejectionReason(x.reason))}`;
    });
  };

  return (
    <>
      <CollapsibleImportSummary
        importedItemsCount={props.importedQuestionsCount}
        skippedItemsCount={props.skippedQuestionsCount}
        rejectionReasons={getRejectionReasons()}
        isPanelOpen={props.isPanelOpen}
        togglePanel={props.handlePanelToggle}
        isLastSummaryItem={props.isLastSummaryItem}
        importedMessage={t('questions_imported', { count: props.importedQuestionsCount })}
        skippedMessage={t('questions_skipped', { count: props.skippedQuestionsCount })}
      />
    </>
  );
});
